<template>
  <StatusChangeProcedureApplyInput label="退学"
                                   class="status-change-procedure-apply-dropout"
                                   v-on="$listeners"
                                   v-loading="loading"
                                   element-loading-text="数据加载中，请稍等..."
                                   :resolve-form="getApplyInfo">
    <template>
      <slot></slot>
    </template>
    <template #form>
      <el-form size="mini"
               label-width="120px"
               label-suffix="：">
        <el-form-item label="退学原因">
          <el-select v-model="form.reasonCode">
            <template v-if="applyInfo && applyInfo.reasons">
              <el-option v-for="reason in applyInfo.reasons"
                         :key="reason.code"
                         :label="reason.name"
                         :value="reason.code"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isCustomReason"
                      label="退学原因详情">
          <el-input v-model="form.reasonNote"
                    type="textarea"
                    maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="需退还学费">
          <div class="input-group">
            <el-input-number v-model="form.dropoutFee"
                             controls-position="right"
                             :min="0"
                             :precision="2"
                             :step="1"></el-input-number>
            <span class="unit">元</span>
          </div>
        </el-form-item>
      </el-form>
    </template>
  </StatusChangeProcedureApplyInput>
</template>

<script>
import StatusChangeProcedureApplyInput from '../input'
import objectUtils from '../../../../../../../../../util/objectUtils'
export default {
  name: 'StatusChangeProcedureApplyDropout',
  components: {
    StatusChangeProcedureApplyInput
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      applyInfo: null,
      form: {
        reasonCode: '',
        reasonNote: '',
        dropoutFee: undefined
      }
    }
  },
  computed: {
    isCustomReason () {
      const reasonCode = this.form.reasonCode
      if (reasonCode) {
        const applyInfo = this.applyInfo
        if (applyInfo) {
          const reasons = applyInfo.reasons
          if (reasons) {
            let getReason = reasons.find(reason => reason.code === this.form.reasonCode)
            if (getReason) {
              return getReason.custom
            }
          }
        }
      }
    }
  },
  methods: {
    loadApplyInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/status/change/procedure/dropout/applyInfo',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.applyInfo = response.data['applyInfo'] || {}
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    getApplyInfo () {
      return new Promise((resolve, reject) => {
        if (!this.form.reasonCode) {
          reject(new Error('请选择退学原因'))
          return
        }
        if (this.isCustomReason) {
          if (!this.form.reasonNote) {
            reject(new Error('请填写退学原因详情'))
            return
          }
        }
        if (!objectUtils.hasValue(this.form.dropoutFee)) {
          reject(new Error('请填写需退还学费'))
          return
        }
        resolve(this.resolveApply(this.form))
      })
    },
    resolveApply (form) {
      return {
        url: '/workspace/manager/status/change/procedure/dropout/submitApply',
        data: this.$qs.stringify(this.$extend({
          postId: this.studentId
        }, form, this.extraParams))
      }
    }
  },
  mounted () {
    this.loadApplyInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          if (typeof this.form[key] === 'string') {
            this.form[key] = val[key] || ''
          } else {
            this.form[key] = val[key]
          }
        })
      }
    }
  }
}
</script>
